const getters = {
    baseData: state => state.baseData,  // 基础信息
    tmpProject: state => state.baseData.tmpProject,     // 项目模板列表

    user: state => state.user.user,     // 用户信息
    roles: state => state.user.roles,   //  用户权限
    editRole: state => state.user.editRole,   //  用户权限
    mune: state => state.user.mune,      //  左侧导航栏

    projectList: state => state.project.projectList,    // 项目列表信息
    projectInfo: state => state.project.projectInfo,    // 当前项目信息
	
	projectsystemList: state => state.system.projectsystemList,    // 项目子系统列表信息
	projectsystemInfo: state => state.system.projectsystemInfo,    // 当前项目子系统信息

    WS: state => state.socket.WS,        //  socket实例
    WS_MSG: state => state.socket.WS_MSG,   //  socket接收消息
    ws_notice: state => state.socket.ws_notice,   //  socket接收消息
    ws_terminalReading: state => state.socket.ws_terminalReading,   //  socket接收消息

    timingControl: state => state.timingControl,    //  定时管理
    timeDesc: state => state.timingControl.timeDesc,
    settingTime: state => state.timingControl.settingTime,
    timeControlMeters: state => state.timingControl.timeControlMeters,
    timeControlForm: state => state.timingControl.timeControlForm,
    timeKind: state => state.timingControl.timeKind,
    meterGroupList: state => state.timingControl.meterGroupList,

    machine: state => state.machine,
}
export default getters